import React, { Component } from 'react'
import {reduxForm, Field, Fields} from 'redux-form'
import { Row, Col} from 'react-bootstrap'
import InputNumerical from '../comun/form/InputNumerical'
import InputSelect from '../comun/form/InputSelect'
import InputRangeDatePicker from '../comun/form/InputRangeDatePicker'
import InputCheckBox from '../comun/form/InputCheckBox'
import { DoneAll, Refresh, Delete, Launch, Print, AddCircleOutline, FilterList } from '@material-ui/icons'
import {date_formatter} from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'

class FiltrosEscandallo extends Component {
  constructor () {
    super()
    this.state = {
      openFiltros: false,
      imputSelected: false,
      fitrosSeleccionados: []
    }
  }

  fetchFiltrarEscandallo(values){
    this.props.actions.filtrarEscandallo(values)
  }

   componentDidUpdate (prevProps, prevState) {
    if (prevProps.paginaActual !== this.props.paginaActual) {
      this.props.change('seleccionar-todo', false)
      this.props.actions.deSeleccionarTodosEscandallo()
    }
    if (this.props.datosExcelEscandallo !== prevProps.datosExcelEscandallo) {
      if (this.props.datosExcelEscandallo.excel && this.props.datosExcelEscandallo.excel !== null){
        let pdf = this.props.datosExcelEscandallo.excel
        let element = document.createElement('a')
        element.setAttribute('href', 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.ALMACEN.ESCANDALLOS') + ".xlsx")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.datosPdfEscandallo !== prevProps.datosPdfEscandallo) {
      if (this.props.datosPdfEscandallo.pdf && this.props.datosPdfEscandallo.pdf !== null){
        let pdf = this.props.datosPdfEscandallo.pdf
        let element = document.createElement('a')
        element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(pdf))
        element.setAttribute('download', this.props.t('MENU.ALMACEN.ESCANDALLOS') + ".pdf")
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    }
    if (this.props.formSimpleTable && Object.keys(this.props.formSimpleTable).length > 0) {
      if (this.props.formSimpleTable !== prevProps.formSimpleTable) {
        let contActivos = 0
        if (this.props.formSimpleTable.values) {
          Object.values(this.props.formSimpleTable.values).forEach((value) => {
            if (value === true) {
              contActivos++
            }
          })
          if (contActivos === 0) {
            this.props.change('seleccionar-todo', false)
            this.setState({ imputSelected: false })
            this.props.actions.deSeleccionarTodosEscandallo()
          }
        }
      }
    }
  }

  componentDidMount () {
    this.props.actions.comboTipoDosis()
    this.props.actions.comboNombreEscandallo()
    this.props.actions.filtrarEscandallo({activo:{value: true, label: this.props.t('ESTADO.ACTIVO')}})
    this.props.change('activo', {value: true, label: this.props.t('ESTADO.ACTIVO')})
  }

  abrirFiltros = (event) => {
    this.setState({ openFiltros: true })
  }

  cerrarFiltros = (event) => {
    this.setState({ openFiltros: false })
  }

  intercambiarCheck = (value) => {
    this.setState({ imputSelected: value })
    if (value === true) {
      this.props.actions.seleccionarTodosEscandallo()
    } else {
      this.props.actions.deSeleccionarTodosEscandallo()
    }
  }

 cambiarEstadoSeleccionEscandallo(){
    const itemsSeleccion = this.props.listEscandallo.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idEscandallo': row.idEscandallo
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.cambiarEstadoSeleccionEscandallo(list)
  }

  deleteSeleccionEscandallo(){
    const itemsSeleccion = this.props.listEscandallo.map((row) => {
      return this.props.formSimpleTable.values['check' + row.idElemento] === true && (
        {
          'check': this.props.formSimpleTable.values['check' + row.idElemento],
          'idEscandallo': row.idEscandallo
        }
      )
    })

    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.deleteSeleccionEscandallo(list)
  }

  crearCsvEscandallo(){
    this.props.actions.crearCsvEscandallo(this.props.filtros)
  }

  imprimirPdfEscandallo () {
    this.props.actions.imprimirPdfEscandallo(this.props.filtros)
  }

  quitarFiltros (value) {
    let values = this.props.filtros
    values[value] = null
    this.props.actions.filtrarEscandallo(values)
    this.props.change(value, null)
    this.setState({fitrosSeleccionados: values})
  }

  render () {
  const {
    t, handleSubmit, filtros,
    actions: {
      abrirModalEscandallo
    },
    combos: {
      comboNombreEscandallo, comboTipoDosis, comboReferenciaEscandallo
    }
  } = this.props

  let comboEstado = this.props.combos.comboEstado
  comboEstado = comboEstado.map((estado) => {
    return {...estado, label: t(estado.label)}
  })

    const tKey = 'ALMACEN.ESCANDALLO.'

  const comboTrazabilidad = [
    {value: true, label: this.props.t('COMUN.COMBOS.TRAZABILIDAD.SI')},
    {value: false, label: this.props.t('COMUN.COMBOS.TRAZABILIDAD.NO')}
  ]

  const comboValidacion = [
    {value: true, label: this.props.t('COMUN.COMBOS.VALIDACION.SI')},
    {value: false, label: this.props.t('COMUN.COMBOS.VALIDACION.NO')}
  ]

  const comboDosis = comboTipoDosis.map((dosis) => dosis)
  const comboDosisFiltros = []
  comboDosis.forEach(function(dosis){
    comboDosisFiltros.push({
      value: dosis.value,
      label: dosis.label
    })
  })

  return (
      <div>
        <div className={this.state.openFiltros === true ? 'tabla-filtros open-filters' : 'tabla-filtros'}>
          <form className="custom-form">
            <Field
              colSm={2}
              id="nombre"
              name="nombre"
              controlLabel={t('ALMACEN.ESCANDALLO.FILTROS.NOMBRE')}
              component={InputSelect}
              options={comboNombreEscandallo}
              valueKey="value"
              labelKey="label"
              customClass='select-escandallo'
              onInputChange={handleSubmit(this.fetchFiltrarEscandallo.bind(this))}
            />
            <Field
              colSm={2}
              id="tipoDosis"
              name="tipoDosis"
              controlLabel={t('ALMACEN.ESCANDALLO.FILTROS.TIPO_DOSIS')}
              component={InputSelect}
              options={comboDosisFiltros}
              valueKey="value"
              labelKey="label"
              customClass='select-escandallo'
              onInputChange={handleSubmit(this.fetchFiltrarEscandallo.bind(this))}
            />
            <Field
              colSm={2}
              id="activo"
              name="activo"
              controlLabel={t('ALMACEN.ESCANDALLO.FILTROS.ACTIVO')}
              component={InputSelect}
              options={comboEstado}
              valueKey="value"
              labelKey="label"
              customClass='select-escandallo'
              onInputChange={handleSubmit(this.fetchFiltrarEscandallo.bind(this))}
            />
            <div className="aplicar-tabla-filtros">
              <div className="filtros-anadidos">
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.nombre && filtros.nombre !== null ? (
                      <span className="badge-dark">{t(tKey + 'FILTROS.NOMBRE') + ': ' + filtros.nombre.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('nombre')}> x </button></span>
                    ) : null
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.tipoDosis && filtros.tipoDosis !== null ? (
                      <span className="badge-dark">{t(tKey + 'FILTROS.TIPO_DOSIS') + ': ' + filtros.tipoDosis.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('tipoDosis')}> x </button></span>
                    ) : null
                  )
                }
                {
                  Object.keys(filtros).length > 0 && (
                    filtros.activo && filtros.activo !== null ? (
                      <span className="badge-dark">{t(tKey + 'FILTROS.ACTIVO') + ': ' + filtros.activo.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('activo')}> x </button></span>
                    ) : null
                  )
                }
              </div>
            </div>
          </form>
        </div>
        <Row className="acciones-tabla-filtros">
          <Col sm={10}>
            <div className="buttons-flex">
              {(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ESCANDALLOS] > 1) && [
                <div className="custom-check-w" key="custom-check-w">
                  <Field
                    id="seleccionar-todo"
                    name="seleccionar-todo"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheck(value)}
                  />
                </div>,
                <div id="block-options" key="block-options" className={this.state.imputSelected === true ? 'button-group buttons-min block-options' : 'button-group buttons-min block-options oculta-action'}>
                  <button type="button" data-toggle="modal" data-target="#cambio-estado" className="btn btn-icono" onClick={(e) => this.cambiarEstadoSeleccionEscandallo()}>
                    <Refresh></Refresh> {t('TITULOS_BOTONES.CAMBIAR_ESTADO')}
                  </button>
                  <button type="button" data-toggle="modal" data-target="#delete-modal" className="btn btn-icono" onClick={(e) => this.deleteSeleccionEscandallo()}>
                    <Delete></Delete> {t('TITULOS_BOTONES.ELIMINAR')}
                  </button>
                  <div className="barra-buttons-min"></div>
                </div>
              ]}
              <div className="button-group buttons-min">
                <button type="button" className="btn btn-icono" onClick={(e) => this.crearCsvEscandallo()}>
                  <Launch></Launch> {t('TITULOS_BOTONES.EXPORTAR')}
                </button>
                <button type="button" className="btn btn-icono" onClick={(e) => this.imprimirPdfEscandallo()}>
                  <Print></Print> {t('TITULOS_BOTONES.IMPRIMIR')}
                </button>
                <button
                  type="button"
                  data-toggle="modal"
                  data-target="#new-edit-modal"
                  className={"btn btn-primary nuevo" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ESCANDALLOS] < 2) ? ' disabled' : '')}
                  onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ESCANDALLOS] > 1) ? abrirModalEscandallo : undefined}
                >
                  <AddCircleOutline></AddCircleOutline> {t('TITULOS_BOTONES.NUEVO')}
                </button>
              </div>
            </div>
          </Col>
          <Col sm={2} className="content-button-filtro">
            <div className="button-group buttons-min button-filtro">
              <div className={this.state.openFiltros === true ? 'btn filters-desp opener-open' : 'btn filters-desp'} onClick={(e) => this.state.openFiltros === false ? this.abrirFiltros() : this.cerrarFiltros()}>
                <FilterList></FilterList> {t('TITULOS_BOTONES.FILTROS')}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'filtrosEscandallo',
})(FiltrosEscandallo))
